module.exports = __webpack_public_path__ + "img/111.9fb5f0d2.jpeg";